import React from "react";
import { HOME_THEME, primaryBtn, secondaryBtn } from "../../features/home/theme";
import { translations, LanguageCode } from "../../utils/translations";

interface HeroSectionProps {
  lang?: LanguageCode;
}

const HeroSection: React.FC<HeroSectionProps> = ({ lang = "en" }) => {
  const content = translations[lang].automatePage;

  return (
    <section style={styles.hero}>
      <div style={styles.container}>
        <div style={styles.eyebrow}>{content.eyebrow}</div>
        <h1 style={styles.title}>{content.heroTitle}</h1>
        <p style={styles.subtitle}>{content.heroSubtitle}</p>
        <div style={styles.btnRow}>
          <button style={primaryBtn}>{content.heroPrimaryBtn}</button>
          <button style={secondaryBtn()}>{content.heroSecondaryBtn}</button>
        </div>
      </div>
    </section>
  );
};

const styles = {
  hero: {
    padding: "48px 5% 52px",
    textAlign: "center" as const,
    background: `linear-gradient(160deg, ${HOME_THEME.surfaceAlt} 0%, ${HOME_THEME.surface} 60%)`,
  },
  container: {
    maxWidth: "900px",
    margin: "0 auto",
  },
  eyebrow: {
    color: HOME_THEME.primary,
    fontWeight: 800,
    fontSize: "0.8rem",
    letterSpacing: "1.5px",
    textTransform: "uppercase" as const,
    marginBottom: "10px",
  },
  title: {
    fontSize: "2.5rem",
    fontWeight: 800,
    lineHeight: 1.15,
    margin: "0 0 14px 0",
    color: HOME_THEME.heroHeading,
  },
  subtitle: {
    fontSize: "1.05rem",
    lineHeight: 1.55,
    maxWidth: "620px",
    margin: "0 auto 26px",
    color: HOME_THEME.muted,
  },
  btnRow: {
    display: "flex",
    gap: "12px",
    justifyContent: "center",
    flexWrap: "wrap" as const,
  },
};

export default HeroSection;
